export default "__VITE_ASSET__59e55e9e__"